/* eslint-disable prettier/prettier */
import request from '@/utils/request'

// 获取供应商认定申请研发认定工程师信息
export function supplierApplyInfo(query) {
    return request({
        url: '/api/srm-base/struBizUser/page',
        method: 'get',
        params: query
    })
}

